import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@ting/ting-ui-components";
export const CallbackAction = ({ icon, action }) => {
    return (_jsx(Button, { v2: true, icon: icon, size: "small", type: "neutral", onClick: () => {
            if (action)
                action();
        } }));
};
